import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import SubscriptionPlanAppResource from './SubscriptionPlanAppResource';
import OrganizationAppResource from './OrganizationAppResource';

export const HOAI_UPGRADE_EXPERIENCE = '04511b47-d0b3-414d-86d1-3c3772c00161';
export const CORELOGIC_UPGRADE_EXPERIENCE = '75a260c5-72ad-4e7b-9e57-efd8db0a3c88';

class UpgradeExperienceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'upgrade-experience';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'upgrades/experiences';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'firstPlanUuid',
            'secondPlanUuid',
            'thirdPlanUuid',
            'trial',
            'trialDuration',
            'trialPlanUuid',
            'isSystem',
            'salesFormUrl',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            firstSubscriptionPlan: SubscriptionPlanAppResource,
            secondSubscriptionPlan: SubscriptionPlanAppResource,
            thirdSubscriptionPlan: SubscriptionPlanAppResource,
            trialSubscriptionPlan: SubscriptionPlanAppResource,
            organizations: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            trial: {
                type: 'boolean',
            },
            trial_duration: {
                type: 'integer',
            },
            is_system: {
                type: 'boolean',
            },
            sales_form_url: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default UpgradeExperienceAppResource;
